/**
 * 404 Not Found Page
 * Displayed when user navigates to an unknown route
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { ROUTES } from '../../routes';
import { useTitle, PAGE_TITLES } from '../../hooks';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  
  // Page title
  useTitle(PAGE_TITLES.NOT_FOUND);

  return (
    <div className="min-h-screen bg-linear-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[180px] font-bold text-slate-100 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-slate-200">
              <Search className="w-12 h-12 text-slate-400 mx-auto" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Halaman Tidak Ditemukan
        </h1>
        <p className="text-slate-600 mb-8 max-w-sm mx-auto">
          Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors w-full sm:w-auto justify-center"
          >
            <ArrowLeft className="w-4 h-4" />
            Kembali
          </button>
          <Link
            to={ROUTES.STATEMENT_RECORDER}
            className="flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors w-full sm:w-auto justify-center"
          >
            <Home className="w-4 h-4" />
            Ke Beranda
          </Link>
        </div>

        {/* Footer hint */}
        <p className="text-xs text-slate-400 mt-12">
          Jika Anda yakin ini adalah kesalahan, hubungi administrator sistem.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
